import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import DFVPlayerAuto from './components/DFVPlayerAuto';
import buildFieldViewStream from './utils/buildFieldViewStream';
import { useDispatch } from 'react-redux';
import dfvPlayViewedAction from './store/actions/dfvPlayViewedAction';
import { DynamicFieldViewLiveWrapper, BetaTagLive } from './DynamicFieldView.style';
import useTracking from '@gameday/utils/hooks/useTracking';
const componentName = 'Dynamic Field View Replay Overlay';
const linkName = componentName + ' View: ';

const DynamicFieldViewLive = ({
    venueId,
    atBatIndex,
    playStartTime,
    gamePk,
    pitchType
}) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [streamError, setStreamError] = useState(false);
    const [autoPlayError, setAutoPlayError] = useState(false);
    const Tracking = useTracking(); ;

    const fieldViewStream = useMemo(() => {
        if (venueId) {
            return buildFieldViewStream({
                venueId,
                useDVR: false,
                gamePk
            });
        }
    }, [venueId]);

    useEffect(() => {
        if (streamError) {
            throw new Error('Stream Error');
        }
    }, [streamError]);

    const DFVCOM = useMemo(() => {
        return <DynamicFieldViewLiveWrapper>
            <BetaTagLive>BETA</BetaTagLive>
            <DFVPlayerAuto
                stream={fieldViewStream?.url}
                setStreamError={setStreamError}
                setAutoPlayError={setAutoPlayError}
                autoPlayError={autoPlayError}
                playEndTime={playStartTime}
                setIsLoading={setIsLoading}
                syncMode={'playEndTime'}
            />
        </DynamicFieldViewLiveWrapper>;
    }, [autoPlayError, fieldViewStream?.url]);

    useEffect(() => {
        return () => {
            dispatch(dfvPlayViewedAction(atBatIndex));
        };
    }, [atBatIndex]);

    useEffect(() => {
        Tracking.track.track_dfv_replay_overlay_launch({
            componentName: [componentName],
            linkName: linkName + pitchType,
            activity: '',
            atBatIndex,
            playStartTime,
            text: ''
        });
    }, [atBatIndex, Tracking, pitchType]);

    return DFVCOM;
};

DynamicFieldViewLive.propTypes = {
    playStartTime: PropTypes.string,
    venueId: PropTypes.number,
    gamePk: PropTypes.number,
    pitchType: PropTypes.string
};

export default DynamicFieldViewLive;
